import React, { useEffect, useMemo, useState } from "react";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import { Form, InputGroup, Stack } from "react-bootstrap";
import MagnifyingGlassIcon from "../icons/MagnifyingGlassIcon";
import { RestrictedLocationData } from "@nestcoinco/hyper-api-gateway-api-client";
import { getRestrictedLocations } from "../../api-clients/complianceGeoLocationClient";
import { GenericModalProps } from "../../utils/constants/generic-types";
import NoLocationPin from "../icons/NoLocationPin";
import "./IneligibleLocations.scss";

export default function IneligibleLocations({
  isOpen,
  onClose,
}: GenericModalProps) {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [ineligibleLocations, setIneligibleLocations] =
    useState<RestrictedLocationData[]>();

  const filteredIneligibleLocations = useMemo(
    () =>
      ineligibleLocations?.filter(
        ({ cityName = "", countryName = "" }) =>
          cityName?.toLowerCase().includes(searchQuery) ||
          countryName.toLowerCase().includes(searchQuery)
      ),
    [searchQuery, ineligibleLocations]
  );

  useEffect(() => {
    (async () => {
      const restrictedLocations = await getRestrictedLocations();
      setIneligibleLocations(restrictedLocations);
    })();
  }, []);

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={onClose}
      containerClass="IneligibleLocationsModal"
    >
      <Stack gap={3} className="pt-2">
        <Stack gap={1}>
          <h1 className="Hanson-700 Heading">Ineligible locations</h1>
          <p className="Grotesk">
            <span className="LastUpdated">Last updated: </span>
            <span className="LastUpdatedDate">Jan 24, 2024</span>
          </p>
        </Stack>

        <InputGroup className="position-relative">
          <InputGroup.Text className="pe-2 SearchIcon">
            <MagnifyingGlassIcon fill="blue" />
          </InputGroup.Text>
          <Form.Control
            size="lg"
            type="search"
            value={searchQuery}
            placeholder="Search"
            aria-label="Search ineligible locations"
            className="ms-0 Grotesk SpecialFontSettings SearchInput"
            onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
          />
        </InputGroup>

        {filteredIneligibleLocations &&
          filteredIneligibleLocations.length > 0 && (
            <Stack as="ul" gap={3} className="p-0 LocationList">
              {filteredIneligibleLocations.map(
                ({ cityName, countryName }, index) => (
                  <li
                    key={`${cityName ?? ""}${countryName}${index}`}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span className="Grotesk Location">
                      {cityName ? `${cityName},` : ""} {countryName}
                    </span>
                    {!cityName && (
                      <span className="Grotesk AllStatesBadge">All states</span>
                    )}
                  </li>
                )
              )}
            </Stack>
          )}

        {(!filteredIneligibleLocations ||
          filteredIneligibleLocations.length === 0) && (
          <Stack className="align-items-center NoResultFound">
            <div className="d-flex justify-content-center align-items-center IconContainer">
              <NoLocationPin />
            </div>
            <p className="Grotesk Copy">No result found</p>
          </Stack>
        )}
      </Stack>
    </BottomDrawer>
  );
}
